<script setup></script>

<template>
    <div class="mt-4 p-4 rounded border-4 border-red">
        <slot></slot>
    </div>
</template>
